import React from 'react';
import { Box, alpha, useTheme } from '@mui/material';
import ImageCarousel from '../../common/ImageCarousel';

/**
 * Section Carrousel - Affichage des images du listing
 */
const CarouselSection = ({ 
  images, 
  title, 
  layout = 'comfortable',
  compactFlex = '30%',
  isHovered = false,
  badges = null,
  actions = null,
  priceOverlay = null
}) => {
  const theme = useTheme();
  
  if (layout === 'compact') {
    return (
      <Box sx={{ 
        flex: `0 0 ${compactFlex}`,
        position: 'relative',
        overflow: 'hidden',
        height: '100%'
      }}>
        <ImageCarousel
          images={images}
          alt={title}
          width="100%"
          height="100%"
          showControls={true}
          showIndicators={images.length > 1}
          showCounter={false}
          autoPlay={false}
          alwaysShowControls={true}
          sx={{ 
            borderRadius: 2, 
            backgroundColor: alpha(theme.palette.background.paper, 0.01)
          }}
        />
      </Box>
    );
  }

  return (
    <Box sx={{ 
      position: 'relative', 
      overflow: 'hidden',
      height: '100%'
    }}>
      <ImageCarousel
        images={images}
        alt={title}
        width="100%"
        height="100%"
        showControls={true}
        showIndicators={images.length > 1}
        showCounter={images.length > 1}
        autoPlay={false}
        alwaysShowControls={true}
        sx={{ 
          borderRadius: '4px 4px 0 0',
          backgroundColor: alpha(theme.palette.background.paper, 0.01)
        }}
      />
      
      {/* Badges overlay */}
      {badges}
      
      {/* Actions overlay */}
      {actions}
      
      {/* Prix en overlay */}
      {priceOverlay}
    </Box>
  );
};

export default CarouselSection;
